import type { ReactNode } from 'react';

/** Visually hidden but available to assistive tech (screen-reader-only text). */
export function VisuallyHidden({ children }: { children: ReactNode }) {
  return <span className="visually-hidden">{children}</span>;
}
